export enum TABS  {
    FIRST = 'first',
    SECOND = 'second',
    THIRD = 'third',
}

export const defaultPageSize = 10
